import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';

const TransitionWrapper = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: #1a1a1a;
  z-index: 999;
  transform-origin: top;
  pointer-events: none;
`;

const PageTransition = () => {
  return (
    <TransitionWrapper
      initial={{ scaleY: 0 }}
      animate={{ scaleY: 0 }}
      exit={{ 
        scaleY: 1,
        transition: { 
          duration: 0.3,
          ease: [0.43, 0.13, 0.23, 0.96]
        } 
      }}
      style={{ originY: 0 }}
    />
  );
};

export default PageTransition;
